import type { UseElementMeasureResult } from './useElementMeasure';

export const defaultElementDimensions: UseElementMeasureResult = {
  absoluteHeight: 0,
  absoluteWidth: 0,
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
};
